import React from 'react';
import type { Member } from '../../types';
import { initials } from '../../utils/labels';
interface AvatarProps {
  member: Member;
  size?: 'sm' | 'md' | 'lg';
}
const sizes = {
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-base'
};
export function Avatar({
  member,
  size = 'md'
}: AvatarProps) {
  const accent = member.type === 'gostujoci' ? 'bg-purple-50 text-purple-700' : 'bg-green-50 text-green-700';
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${accent} ${sizes[size]}`} data-id="element-420" data-mp="1gn4jx5in2teg">
      {initials(member)}
    </span>;
}